// extracted by mini-css-extract-plugin
export default {"statConn":"Doughnut_statConn__TIidC","containerConn":"Doughnut_containerConn__QMHl+"};